import fetch from '../config/api'
/**
 * 志愿者模块首页
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 */
const volunteerIndex = (language = '1') => fetch('/volunteer/index', {
    p: 'wx',
    language
});

/**
 * 志愿者风采列表
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */
const volunteerList = (language = '1', num = '0', take = '10') => fetch('/volunteer/list', {
    p: 'wx',
    language,
    skip: num * take, //从第几个开始
    take //取几条数据
});

/**
 * 志愿者风采详情
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {activity_id} 活动ID
 */
const VolunteerDetail = (language = '1', volunteer_id) => fetch('/volunteer/detail', {
    p: 'wx',
    language,
    volunteer_id
});

export default {
    volunteerIndex,
    volunteerList,
    VolunteerDetail
}